export { TrendIndicator } from './TrendIndicator';
export { TrendIndicatorProps } from './TrendIndicator.types';
